import '../App.css';
import { useState } from 'react';
import scribble from '../images/scribble1.png'

function Contact() {

    const [submitted, setSubmitted] = useState(false)
    const [loading, setLoading] = useState(false)

    async function send(formData: any) {
        const name: string = formData.get("firstName") + " " + formData.get("lastName")
        const email: string = formData.get("email")
        const subject: string = formData.get("subject")
        const message: string = formData.get("message")
        const plaintextMessage = "Name: " + name + "\nEmail: " + email + "\nMessage: " + message
        const htmlMessage = `<p><b>Name: </b>${name}</p><p><b>Email: </b>${email}</p><p><b>Message: </b>${message}</p>`

        const body = JSON.stringify({
            "Messages": [{
                "From": { "Email": "bgavsite@gmail.com", "Name": name },
                "To": [{ "Email": "bhargavbannigeri+website@gmail.com" }],
                "Subject": subject,
                "TextPart": plaintextMessage,
                "HtmlPart": htmlMessage
            }]
        });

        let options = {
            method: "POST",
            body: body
        }

        setLoading(true)

        fetch("/send", options)
            .then(() => {
                // setLoading(false)
                setSubmitted(true)
            })
    }

    const form = (<>
        <form action={send} className="App-contact-form">
            <div style={{ display: 'flex', flexDirection: "row" }}>
                <div style={{ margin: "1vh" }}>
                    <span>First Name</span>
                    <br />
                    <input required name="firstName" className='App-input' />
                </div>
                <div style={{ margin: "1vh" }}>
                    <span>Last Name</span>
                    <br />
                    <input name="lastName" className='App-input' />
                </div>
            </div>
            <div style={{ display: 'flex', flexDirection: "row" }}>
                <div style={{ margin: "1vh" }}>
                    <span>Email</span>
                    <br />
                    <input required name="email" className='App-input' />
                </div>
                <div style={{ margin: "1vh" }}>
                    <span>Subject</span>
                    <br />
                    <input required name="subject" className='App-input' />
                </div>
            </div>
            <div style={{ margin: "1vh" }}>
                <span>Message</span>
                <br />
                <textarea required name="message" rows={6} cols={60} className='App-input-longform' />
            </div>
            <button type="submit" className='App-formButton'>Send</button>
        </form>
    </>)

    return (
        <div className="App-body">
            <p style={{ width: "min(60vh,100%)", margin: "1vh" }}>
                I am available for freelance music work, be it production, composition, mixing, or making mashups for your needs.
                If you have any projects I can help out with or want to get in touch for any reason, please reach out!
            </p>
            {submitted ? <p style={{margin:"1vh", marginTop:"5vh"}}>Submitted! I will try to respond as soon as I can!</p> : (loading? <progress/> : form) }
            <div style={{width:"100%"}}></div>
            <img src={scribble} alt="" style={{height:"18vh", marginTop:"5vh"}} onContextMenu={()=>{return false;}} draggable={false}/>
        </div>
    );
}

export default Contact;